export const FRUITFUL_SUPPORT_PHONE_DISPLAY = '(833) 784-8050';
export const FRUITFUL_SUPPORT_PHONE_URL = 'tel:8337848050';

export enum StorageKeys {
    MEMBER_INFO = 'MEMBER_INFO',
    HAS_SEEN_BIOMETRICS_PROMPT = 'HAS_SEEN_BIOMETRICS_PROMPT',
    HAS_SEEN_NOTIFICATIONS_PROMPT = 'HAS_SEEN_NOTIFICATIONS_PROMPT',
    REDIRECT_PATH = 'REDIRECT_PATH',
    GUIDE_MESSAGING_DRAFT = 'GUIDE_MESSAGING_DRAFT',
    GOAL_COMPLETE_NOTIFICATIONS = 'GOAL_COMPLETE_NOTIFICATIONS',
    DEVICE_TOKEN = 'device.token', // Written to by NextJS app.
    USER_TOKEN = 'user.token', // Read by NextJS app.
    LATEST_ACTIVITY_TIMESTAMP = 'LATEST_ACTIVITY_TIMESTAMP',
    BANKING_EXPERIENCE_OVERRIDE = 'BANKING_EXPERIENCE_OVERRIDE',
    EMPLOYMENT_UPDATE_PROMPT_TIMESTAMP = 'EMPLOYMENT_UPDATE_PROMPT_TIMESTAMP',
    LATEST_SESSION_ID = 'LATEST_SESSION_ID',
    HOLISTIC_SUMMARY_CACHE = 'HOLISTIC_SUMMARY_CACHE',
    SPEND_WIDGET_PERIOD = 'SPEND_WIDGET_PERIOD',
    CONVERSATIONAL_MM_THREAD_ID = 'CONVERSATIONAL_MM_THREAD_ID',
    VISITOR_ID = 'VISITOR_ID',
    CONVERSATIONAL_MM_ONBOARDING_CHAT_RESULTS = 'CONVERSATIONAL_MM_ONBOARDING_CHAT_RESULTS',
    CONVERSATIONAL_MM_WELCOME_SELECTION = 'CONVERSATIONAL_MM_WELCOME_SELECTION',
    SIGNUP_FLOW_SELECTED_GUIDE = 'user.signup.selectedGuide', // Origin: webflow site code, JSON string expected
    SIGNUP_FLOW_VERSION = 'user.signup.flowVersion', // Origin: webflow site code, required during "no-guide-selection" experiment
    HAS_SEEN_CONVERSATIONAL_MM_GUIDED_TOOLTIPS = 'HAS_SEEN_CONVERSATIONAL_MM_GUIDED_TOOLTIPS',
    SPROUT_THREAD_ID = 'SPROUT_THREAD_ID',
    SPROUT_STREAM_OPTIONS = 'SPROUT_STREAM_OPTIONS',
    SPROUT_SEND_TO_GUIDE_SENT_IDS = 'SPROUT_SEND_TO_GUIDE_SENT_IDS',
}
